import MygradeCard from "../../assets/mygradecard.png";
import Proptter from "../../assets/proptter.png";
import Pay363 from "../../assets/pay363.png";

const FeaturedProducts = () => {
  const featuredProducts = [
    {
      logo: MygradeCard,
      name: "My GradeCard",
      description:
        "A comprehensive school result and management system designed to simplify grading, attendance, and administrative tasks. My GradeCard offers advanced analytics, real-time performance tracking, and customizable dashboards for teachers, students, and school administrators.",
      cta: "Learn More",
      ctaLink: "https://mygradecard.online",
    },
    {
      logo: Proptter,
      name: "Proptter ID",
      description:
        "A secure federated login and identity management system that allows seamless access to all your applications using a single ID. Proptter ID enhances user experience while strengthening authentication and access control across educational and enterprise platforms.",
      cta: "See Features",
      ctaLink: "https://proptter.com",
    },
    {
      logo: Pay363,
      name: "Pay363",
      description:
        "A modern payment and billing platform built for speed, security, and convenience. Pay363 enables seamless transactions, utility bill payments, and subscription management with end-to-end encryption and fraud detection for both individuals and businesses.",
      cta: "Explore Pay363",
      ctaLink: "https://pay363.com",
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Our Products</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Discover our flagship products designed to help your business thrive in the digital landscape.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-10">
          {featuredProducts.map((product, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-md border border-gray-100 p-6 flex flex-col items-start justify-between hover:shadow-lg transition-all duration-300"
            >
              <img src={product.logo} alt={product.name} className="w-20 h-20 mb-4" />
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{product.name}</h3>
              <p className="text-gray-600 mb-6 text-sm">{product.description}</p>
              <button
                onClick={() => window.open(product.ctaLink, "_blank")}
                className="text-blue-600 font-medium inline-flex items-center hover:underline"
              >
                {product.cta}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 ml-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
